import ArrowIosUp from '@crehana/icons/outline/ArrowIosUp';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { transition } from '@crehana/ui';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var MenuDesktopLink = function MenuDesktopLink(_ref) {
  var children = _ref.children,
    isSelected = _ref.isSelected,
    toggleDropdown = _ref.toggleDropdown,
    isBottomLink = _ref.isBottomLink,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: clsx('tw-w-full sm:min-w-212', isBottomLink ? 'tw-my-[2px]' : 'tw-my-0.4'),
    onClick: toggleDropdown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx('tw-relative z-4 tw-px-0.8 tw-py-0.8 tw-mx-1.2 tw-rounded-[5px]', 'tw-flex tw-items-center tw-justify-between', 'dark:hover:bg-gray-lighter-dark-mode hover:bg-gray-lighter', {
        'tw-bg-neutral-light-200 dark:tw-bg-elevation-dark-02': isSelected
      }),
      style: {
        transition: transition(['background-color', 'box-shadow'])
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "tw-flex tw-items-center tw-w-full tw-cursor-pointer focus:outline-none",
        children: children
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-w-2.4 tw-h-2.4",
        style: {
          transform: "rotate(".concat(isSelected ? '0deg' : '180deg', ")"),
          transition: transition('transform', 300)
        },
        "aria-hidden": true,
        children: /*#__PURE__*/_jsx(ArrowIosUp, {
          size: 20,
          ignoreColor: true,
          className: clsx('tw-fill-current', isSelected && 'tw-text-neutral-dark-700 dark:tw-text-neutral-dark-300')
        })
      })]
    })
  });
};